import Nullstack from 'nullstack';
export default function IconTwoFactorAuth({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-2fa",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7 16h-4l3.47 -4.66a2 2 0 1 0 -3.47 -1.54"
  }), "   ", Nullstack.element("path", {
    d: "M10 16v-8h4"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "12",
    x2: "13",
    y2: "12"
  }), "   ", Nullstack.element("path", {
    d: "M17 16v-6a2 2 0 0 1 4 0v6"
  }), "   ", Nullstack.element("line", {
    x1: "17",
    y1: "13",
    x2: "21",
    y2: "13"
  }), " ");
}